export enum ResidentialStatus_Enum {
  "Home Owner" = 1,
  "Private Tenant" = 2,
  "Council Tenant" = 3,
  "Living With Parents" = 4
}
